import { NameCell } from '@prometheus/features';
import { Button, Icon } from '@prometheus/components';
export const colsTableEnviroments = (t: any, onOpen): any => [
  {
    Header: t('tables.cols.label'),
    accessor: 'label',
    id: 'label',
    minWidth: 200,
    width: '30%',
    isCropped: true,
    Cell: NameCell,
  },

  {
    Header: t('tables.cols.descriptor'),
    accessor: 'id',
    id: 'actionCell',
    width: '10%',
    minWidth: 80,
    disableSortBy: true,
    Cell: props => {
      return (
        <Button
          size="small"
          onClick={() => onOpen(props.value)}
          color="info"
          variant="outlined"
          sx={{
            px: 2,
            py: 0.25,
            borderRadius: 0.5,
            fontSize: 12,
            minWidth: 98,
          }}
        >
          {t('buttons.show')}
        </Button>
      );
    },
  },
];
